import React, { useState } from 'react';
import { Checkbox } from 'components/Checkbox';
import { useMap } from 'contexts/MapContext';
import { getVehicleColor } from 'utils/colorPalette';

import './styles.scss';
import { ChevronDownIcon, ChevronUpIcon } from 'assets';

export function MapAssets() {
  const { assets, toggleAssetVisibility, setAllAssetsVisibility, setHoveredAsset, state } = useMap();
  const [isExpanded, setIsExpanded] = useState(true);

  const { hoveredAssetId, colorTrailsEnabled, colorTrailsMode } = state;
  const visibleAssets = assets.filter((asset) => asset.visible !== false);
  const allVisible = visibleAssets.length === assets.length;
  const someVisible = visibleAssets.length > 0 && visibleAssets.length < assets.length;

  const handleSelectAll = () => {
    setAllAssetsVisibility(!allVisible);
  };

  const handleAssetToggle = (assetId: number) => () => {
    toggleAssetVisibility(assetId);
  };

  const handleAssetHover = (assetId: number) => () => {
    setHoveredAsset(assetId);
  };

  const handleAssetLeave = () => {
    setHoveredAsset(null);
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (assets.length === 0) {
    return null;
  }

  return (
    <div className="MapAssets">
      <div className={`MapAssets-header ${!isExpanded ? 'MapAssets-header--collapsed' : ''}`} onClick={toggleExpanded}>
        {!isExpanded ? (
          <ChevronDownIcon className="MapOptions-toggle MapOptions-toggle--active" />
        ) : (
          <ChevronUpIcon className="MapOptions-toggle" />
        )}
        <h3 className="MapAssets-title">VEHICLES</h3>
      </div>

      {isExpanded && (
        <div className="MapAssets-content">
          <div className="MapAssets-selectAll">
            <Checkbox isChecked={allVisible} indeterminate={someVisible} onChange={handleSelectAll} />
            <span className="MapAssets-selectAllLabel">Select All</span>
          </div>

          <div className="MapAssets-list">
            {assets.map((asset, assetIndex) => (
              <div 
                key={asset.id} 
                className={`MapAssets-item ${hoveredAssetId === asset.id ? 'MapAssets-item--hovered' : ''}`}
                onMouseEnter={handleAssetHover(asset.id)}
                onMouseLeave={handleAssetLeave}
              >
                <Checkbox isChecked={asset.visible !== false} onChange={handleAssetToggle(asset.id)} />
                <span className="MapAssets-itemLabel" onClick={handleAssetToggle(asset.id)}>
                  {colorTrailsEnabled && colorTrailsMode === 'vehicle' && (
                    <span 
                      className="MapAssets-colorIndicator"
                      style={{ backgroundColor: getVehicleColor(assetIndex) }}
                    />
                  )}
                  {asset.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
